import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return (_openBlock(), _createBlock(_component_SvgIcon, {
    "symbol-data": _ctx.symbolData()
  }, null, 8, ["symbol-data"]))
}